module.exports = __webpack_public_path__ + "img/magnify.0a1c86d3.svg";